export default {
  apiUrl: 'https://api.stg.hummingbirdtech.com',
  appUrl: 'app.staging.hummingbirdtech.com',
  gqlGatewayUrl: 'https://farm-api.stg.hummingbirdtech.com',
  uploaderUrl: 'https://uploader.staging.hummingbirdtech.com',
};
